import {ReactNode} from 'react'
import {StyledNavLink} from '@components/ui/NavLink/style.ts'

interface NavLinkProps {
    size?: 'sm' | 'md' | 'lg'
    variant?: 'ghost'
    name?: string
    path: string
    end?: boolean
    icon?: ReactNode
}

const NavLink = ({icon, name, path, end = true, variant = 'ghost'}: NavLinkProps) => (
    <StyledNavLink size={'sm'} variant={variant} to={path} end={end}>
        {icon && icon}
        {name && name}
    </StyledNavLink>
)

export default NavLink

NavLink.displayName = 'NavLink'
